/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ScenarioChatFragment = { guid: string, title: string, messages: Array<{ guid: string, body: string, selectionsV2:
      | { __typename: 'ScenarioChatMessageBasicSelections', basicSelections: Array<{ guid: string, label: string, nextMessageIndex: number | null, actions: Array<{ assignedStaffGUID: string }> }> }
      | { __typename: 'ScenarioChatMessageBookingRequestSelections', fallbackUrl: string | null }
     | null }> };

export type ScenarioChatMesageFragment = { guid: string, body: string, selectionsV2:
    | { __typename: 'ScenarioChatMessageBasicSelections', basicSelections: Array<{ guid: string, label: string, nextMessageIndex: number | null, actions: Array<{ assignedStaffGUID: string }> }> }
    | { __typename: 'ScenarioChatMessageBookingRequestSelections', fallbackUrl: string | null }
   | null };

export type ScenarioChatMessageBasicSelectionFragment = { guid: string, label: string, nextMessageIndex: number | null, actions: Array<{ assignedStaffGUID: string }> };

export type ScenarioChatFormQueryFragment = { staffsByPlanner: Array<{ guid: string, displayName: string }> };

export type ScenarioChatStaffFragment = { guid: string, displayName: string };

export const ScenarioChatMessageBasicSelectionFragmentDoc = gql`
    fragment ScenarioChatMessageBasicSelection on ScenarioChatMessageBasicSelection {
  guid
  label
  nextMessageIndex
  actions {
    ... on ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch {
      assignedStaffGUID
    }
  }
}
    `;
export const ScenarioChatMesageFragmentDoc = gql`
    fragment ScenarioChatMesage on ScenarioChatMessage {
  guid
  body
  selectionsV2 {
    __typename
    ... on ScenarioChatMessageBasicSelections {
      basicSelections {
        ...ScenarioChatMessageBasicSelection
      }
    }
    ... on ScenarioChatMessageBookingRequestSelections {
      fallbackUrl
    }
  }
}
    ${ScenarioChatMessageBasicSelectionFragmentDoc}`;
export const ScenarioChatFragmentDoc = gql`
    fragment ScenarioChat on ScenarioChat {
  guid
  title
  messages {
    ...ScenarioChatMesage
  }
}
    ${ScenarioChatMesageFragmentDoc}`;
export const ScenarioChatStaffFragmentDoc = gql`
    fragment ScenarioChatStaff on Staff {
  guid
  displayName
}
    `;
export const ScenarioChatFormQueryFragmentDoc = gql`
    fragment ScenarioChatFormQuery on Query {
  staffsByPlanner {
    ...ScenarioChatStaff
  }
}
    ${ScenarioChatStaffFragmentDoc}`;